/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

// import { Linkable } from '@/components/blocks/Linkable';
import { forgotPasswordButtonSX } from '@/components/content/ForgotPassword/styles/button';
import { forgotPasswordContainerSX } from '@/components/content/ForgotPassword/styles/container';
// import { forgotPasswordSignInButtonSX } from '@/components/content/ForgotPassword/styles/signInButton';
import { useForgotPassword } from '@/data/Content/ForgotPassword';
import { useLocalization } from '@/data/Localization';
// import { ADDRESS_FIELD_LENGTH } from '@/data/constants/addressFields';
import { ID } from '@/data/types/Basic';
import { useForm } from '@/utils/useForm';
import {
	Divider,
	// Divider,
	Grid,
	Paper,
	Stack,
	Typography,
} from '@mui/material';
// import { useTheme } from '@mui/material/styles';
import { FC } from 'react';
import { EMPTY_STRING } from '@/data/constants/marketing';
import { useTheme } from '@mui/material/styles';
import { useMediaQuery } from '@mui/material';
import { DpOutlinedInput } from '@/components/blocks/OutlinedInput';
import { loginContainerSX } from '@/components/content/Login/styles/container';
import { Linkable } from '@/components/blocks/Linkable';
import { loginIsButtonSX, loginLabelSX } from '@/components/content/Register/styles/container';
import { DpButton } from '@/components/blocks/DpLibrary/DpButton';

export const ForgotPassword: FC<{ id: ID }> = () => {
	const ForgotPasswordNLS = useLocalization('ForgotPassword');
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
	const { initialForgotPassword, forgotPasswordSubmit } = useForgotPassword();

	const {
		formRef,
		values: forgotPasswordValues,
		handleInputChange,
		handleSubmit,
		error,
	} = useForm(initialForgotPassword);

	const contentSpacingLogin = {
		xs: 2,
		sm: 2,
		md: 6,
		lg: 25.5,
	};
	const RouteLocal = useLocalization('Routes');

	const handlePhoneChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const value = event.target.value.replace(/[^0-9]/g, '');

		if (value.length <= 10) {
			handleInputChange(event);
		}
	};

	return (
		<Grid container spacing={contentSpacingLogin} sx={{ marginTop: 'auto' }}>
			<Grid item xs={12} md={6} m="auto">
				<Paper
					sx={forgotPasswordContainerSX({ isMobile })}
					component="form"
					onSubmit={handleSubmit(forgotPasswordSubmit)}
					ref={formRef}
					noValidate
				>
					<Stack spacing={3}>
						<Stack spacing={0}>
							<Typography
								component={'h1'}
								sx={{
									fontSize: { md: 'var(--font-size-xl)', xs: 'var(--font-size-lg)' },
									fontWeight: '800',
									letterSpacing: '0px',
									color: '#2C2C2C',
									textTransform: 'uppercase',
									opacity: 1,
								}}
							>
								{ForgotPasswordNLS.Title.t()}
							</Typography>
							<Typography
								sx={{
									fontSize: 'var(--font-size-sm)',
									fontWeight: '400',
									letterSpacing: '0px',
									color: '#2C2C2C',
									opacity: 1,
								}}
							>
								{
									'Introduzca su número de teléfono. Recibirá un código de verificación para restablecer su contraseña.'
								}
							</Typography>
							<DpOutlinedInput
								sx={{ marginTop: '28px !important' }}
								variant="outlined"
								margin="normal"
								required
								name="email"
								autoComplete="tel"
								label="Número de teléfono"
								autoFocus
								color="primary"
								value={forgotPasswordValues.email}
								onChange={handlePhoneChange}
								inputProps={{
									maxLength: 10,
									type: 'tel',
									placeholder: 'Número de teléfono',
								}}
								error={error.email}
								helperText={error.email ? 'Número de teléfono no válido' : EMPTY_STRING}
							/>
						</Stack>
						<Stack alignItems="center">
							<DpButton
								type="submit"
								variant="primary"
								sx={forgotPasswordButtonSX}
								data-testid="button-forgot-password-send-verification-code"
								id="button-forgot-password-send-verification-code"
							>
								{'Continuar'}
							</DpButton>
						</Stack>
					</Stack>
				</Paper>
				<Paper
					sx={{
						...loginContainerSX({ isMobile }),
						pt: { md: '17px', xs: '0px' },
						backgroundColor: 'transparent',
						mt: { md: '0px', xs: '0px' },
					}}
				>
					{isMobile ? <Divider sx={{ marginBottom: '15px' }} /> : null}
					<Stack alignItems="center" spacing={2}>
						<Typography sx={loginLabelSX}>{'¿Ya tienes cuenta?'}</Typography>
						<Linkable
							href={`/${RouteLocal.Login.route.t()}`}
							type="button"
							variant="contained"
							sx={loginIsButtonSX}
						>
							{'Inicia sesión'}
						</Linkable>
					</Stack>
				</Paper>
			</Grid>
		</Grid>
	);
};
